import styled from 'styled-components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SearchOutlined as SearchOutlinedIcon } from '@material-ui/icons';
import { Autocomplete, ContentLoader, FilterIcon, FiltersPopover, palette } from '@dev/ee-components';
import { ReportLocationStats } from '@dev/ee-api/ee-api-models';

import { getReportsState } from '@/store/reports/actions';

import { GeographyToggleBtnValues, SearchAndFilterProps } from '../CampaignReportGeographyInterface';

const AutocompleteCustom = styled(Autocomplete)<any>`
    width: 100%;
    padding-right: 16px;
`;

const IconWrapper = styled.div`
    background: ${palette.basic.paper};
    border: 1px solid ${palette.indigo[6]};
    border-radius: 4px;
    height: 44px;
    width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    display: flex;
    margin-bottom: 24px;
`;

const SearchAndSortWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

const ContentLoaderWrapper = styled.div`
    padding-right: 16px;
    flex: 1;
`;

const filterTable = (selectedFilter: Record<string, any>, setCountryStatisticsFormat): void => {
    const pickedRadioValue = selectedFilter[0];

    setCountryStatisticsFormat(pickedRadioValue);
};

const SearchAndFilter: FC<SearchAndFilterProps> = (props: SearchAndFilterProps): JSX.Element => {
    const { locationStats } = useSelector(getReportsState);
    const { t } = useTranslation();
    const { countryStatisticsFormat, setCountryStatisticsFormat, setSearchResult } = props;
    const filterOptions = [
        { label: t('count'), value: GeographyToggleBtnValues.Number },
        { label: t('percentage'), value: GeographyToggleBtnValues.Percent },
    ];

    return (
        <SearchAndSortWrapper>
            {!locationStats.loading ? (
                <AutocompleteCustom
                    id="search"
                    placeholder={t('searchforcountries')}
                    startIcon={<SearchOutlinedIcon style={{ color: palette.gray[6] }} />}
                    options={locationStats.dataSet as ReportLocationStats[]}
                    getOptionLabel={(option): string => option.Country}
                    onChange={(e: any, obj: any, reason: any): void => {
                        reason === 'clear' ? setSearchResult([]) : setSearchResult([obj]);
                    }}
                />
            ) : (
                <ContentLoaderWrapper>
                    <ContentLoader mode="row" height="44px" />
                </ContentLoaderWrapper>
            )}
            <IconWrapper>
                <FiltersPopover
                    title={t('filters')}
                    onApply={(selectedFilter) => filterTable(selectedFilter, setCountryStatisticsFormat)}
                    translations={{ apply: t('apply'), close: t('close') }}
                    tabs={[
                        {
                            label: '',
                            options: filterOptions,
                            defaultValue: countryStatisticsFormat,
                            type: 'radio',
                        },
                    ]}
                >
                    <FilterIcon />
                </FiltersPopover>
            </IconWrapper>
        </SearchAndSortWrapper>
    );
};

export default SearchAndFilter;
